import { replaceMultipleTexts } from '@app/utils';

// Store
export const appErrorFetchStore = 'Failed to fetch store details.';
export const appErrorFetchStoreById = `Unable to load store. Check store ID value if correct ({0}).`;
export const appErrorStoreBlacklisted = 'Unable to load ClearCar tool. Please contact the administrator.';
export const appErrorFetchDrilldown = 'Failed to fetch drilldown';

// Yes No Questions
export const appYes = 'Yes';
export const appNo = 'No';
export const appNotSure = 'Not sure';

// Form
export const formButtonBack = 'Back';
export const formButtonNext = 'Next';
export const formButtonGetMyOffer = 'Get my Price';

// Offer
export const appGetOfferDescription = 'Share a few details about your vehicle and get a price right away.';
export const appGetOfferHeadline = 'Get Your Price in Minutes';

// Contact
export const appContactInfoDescription = `See your price right away. Add your phone number and we'll send you a copy.`;
export const appContactInfoDescriptionNoPhone = 'See your price right away.';

// Print Button
export const appPrintButton = 'Print';
export const ErrorPrintGeneralError = 'Failed to print.';

// Scanner
export const ErrorScannerCameraAccess = 'Failed to access camera. Please allow on browser site settings.';
export const ErrorScannerGeneralError = 'Failed to setup scanner.';
export const ErrorScannerInitialization = 'Scanner failed to initialize.';
export const ErrorVinMessage = 'Unable to identify VIN message.';
export const ErrorVinScannerScan = 'Failed to scan VIN.';
export const ErrorVinScannerSetup = 'Failed to setup VIN scanner.';

// Errors
export const appErrorSetupNoStoreId = `Please set Store ID through 'data-store-id' attribute on #{0}.`;
export const appErrorSetupStoreIdFormat = `Invalid 'data-store-id' value "{0}". Must be a number.`;
export const appErrorSetupNoCountry = `Please set Country through 'data-country' attribute on #{0}.`;
export const appErrorSetupEmptyStoreId = `Please add a Store ID through 'data-store-id attribute on #{0}, it must not be empty`;
export const appErrorSetupCountryValues = `Invalid value "{0}" on #{1} data-country attribute. Accepted values - {2}.`;
export const appErrorSetupColorAttributes = `Invalid color hex "{0}" on #{1} {2} attribute. Must be 6-digit hex notation.`;
export const appErrorSetupEnumAttributes = `Invalid value "{0}" on #{1} {2} attribute. Accepted values - {3}.`;
export const appNoAnswer = 'N/A.';
export const appErrorSetupTextAttributesLimit = `Please set the value of "{0}" to {1} characters or fewer`;

// Hooks Errors
export const getUserInformationError = 'Cannot get user information';

// Footer
export const appFooterPoweredBy = 'Powered by';

// Step Header
export const appHeaderVehicleInfo = 'VEHICLE INFO';
export const appHeaderConditionOverview = 'CONDITION OVERVIEW';
export const appHeaderVehicleOwnership = 'VEHICLE OWNERSHIP';
export const appHeaderCustomerInfo = 'CUSTOMER INFO';
export const appHeaderOnlineEstimate = 'ONLINE PRICE';

// Form Wrapper
export const appFormWrapperRequiredField = 'Indicates a required field';

// Popover
export const ToolTip = {
  MainTitle: 'Where to find your VIN',
  DashboardTitle: 'Dashboard by the driver’s side',
  DriverSideDescription: 'It’s easiest to see your VIN from outside the car, looking in through the windshield.',
  DoorJambTitle: 'Door jamb by the driver’s side',
  DoorJambDescription: 'It’s easiest to see your VIN by opening your driver side door and looking at the door jamb next to the seat.',
};

// Step Vehicle Selection
export const EnterPlate = 'Enter your license plate to get a price.';
export const EnterVIN = 'Enter your VIN to get a price.';
export const EnterYMM = 'Enter your make and model to get a price.';
export const LicensePlate = 'License Plate';
export const VIN = 'VIN';
export const MakeModel = 'Make & Model';
export const State = 'State';
export const Year = 'Year';
export const Series = 'Trim';
export const Model = 'Model';
export const Make = 'Make';
export const Style = 'Style';
export const VinCodeError = 'Please enter a valid VIN.';
export const LicensePlateError = 'License plate is not valid.';
export const LicensePlateInvalid = 'Please enter a valid License plate, and State.';

export const vehicleSelectionYMMWarning = 'The price you will receive using Year, Make, Model is an estimate based on our historical data and trends. To receive a more accurate price, we recommend using the License Plate Number or VIN information of your car.';

// Step Vehicle Info
export const vehicleInfoHeaderTitle = 'We found your car!';
export const vehicleInfoHeaderInformation = 'Please review and update the information we have about your vehicle so everything is correct.';
export const vehicleInfoLabels = {
  trim: 'Trim',
  style: 'Style',
  color: 'Color',
  mileage: 'Mileage',
  mileageError: `Please enter your vehicle's mileage`,
  zipCode: 'Zip Code',
  zipCodeError: 'Please enter a valid zip code.',
};

export const vehicleToolTipInfo = {
  info: 'Please answer all the required fields.',
  conditionOverview: 'Please choose an option for all the required fields.',
  ownership: 'Please fill in all the required fields.',
  customerInfo: 'Please fill in all the required fields.',
};
export const vehicleInfo = '';
export const vehicleInfoZipCodeError = 'Please enter a valid zip code.';
export const vehicleInfoNextText = 'Get My Price';

// Step Condition Overview
export const vehicleConditionHeaderTitle = 'Vehicle Condition';
export const vehicleConditionHeaderSubtitle = 'Please select the option that best describes the condition of your vehicle. This will help us with your price.';
export const vehicleConditionQuestionOptionEquipmentLabel = 'Vehicle Features';
export const vehicleConditionQuestionTitlePresentDesc = 'Do you have the title under your name?';
export const vehicleConditionQuestionTitleBrandedLabel = 'Title Issues';
export const vehicleConditionQuestionTitleBrandedDesc = 'Does your vehicle have a salvage, rebuilt, or flood damage title?';
export const vehicleConditionQuestionFrameDamageDesc = 'Does your vehicle have any structural damage?';
export const vehicleConditionQuestionRustDamageDesc = 'Does your vehicle have any rust on the body or undercarriage?';
export const vehicleConditionQuestionBodyDamageDesc = 'Does your vehicle have any existing body damage?';
export const vehicleConditionQuestionEngineIssuesDesc = 'Does your vehicle have any of these engine issues?';
export const vehicleConditionQuestionSubQuestionLabel = 'Select Issues';
export const vehicleConditionQuestionInteriorIssuesDesc = 'Does your vehicle have any of these interior issues?';
export const vehicleConditionQuestionMechanicalIssuesDesc = 'Does your vehicle have any of these mechanical issues?';
export const vehicleConditionQuestionWarningLightsDesc = 'Are any of these warning lights displayed on the dashboard?';
export const vehicleConditionQuestionModificationsDesc = 'Does your vehicle have any aftermarket modifications?';
export const vehicleConditionQuestionTireIssuesDesc = 'Does your vehicle have any issues with the tires?';
export const vehicleConditionQuestionTireTreadDesc = 'How is your tire tread?';
export const vehicleConditionQuestionGlassDamageDesc = 'Are there any cracks or chips in the glass?';
export const vehicleConditionQuestionTransmissionDesc = 'What kind of transmission do you have?';
export const vehicleConditionQuestionsKeysDescription = 'How many sets of keys do you have?';
export const vehicleConditionTitle = 'What is the condition of the vehicle?';
export const vehicleConditionGreat = {
  title: 'Your vehicle has its best years ahead of it.',
  option: 'USED MODESTLY',
  list: ['Minimal wear and tear', 'No major mechanical or cosmetic problems', 'Will require limited reconditioning'],
};
export const vehicleConditionOk = {
  title: 'Your vehicle is not past its prime, but getting close.',
  option: 'SEEN BETTER DAYS',
  list: ['Some wear and tear', 'Few minor mechanical and/or minor cosmetic problems', 'Will require some reconditioning'],
};
export const vehicleConditionRough = {
  title: 'Your vehicle needs lots of love.',
  option: 'NEEDS LOTS OF LOVE',
  list: ['A lot of wear and tear', 'Major mechanical and/or body damage', 'Will require significant reconditioning'],
};
export const vehicleConditionAccident = 'Has the vehicle been in an accident?';
export const vehicleConditionAccidentNone = 'NO ACCIDENTS';
export const vehicleConditionAccidentOnce = '1 ACCIDENT';
export const vehicleConditionAccidentTwice = '2 + ACCIDENTS';
export const vehicleConditionWindshield = 'Are there any chips or cracks in the glass?';
export const vehicleConditionRoughCondition = 'Important: Vehicles at this condition tier are more likely to experience adjustments after we inspect the vehicle.';

// Step Ownership
export const stepVehicleOwnershipTitle = 'Ownership';
export const stepVehicleOwnershipLoan = 'Loan';
export const stepVehicleOwnershipLoanDescription = 'I still owe a balance on my current loan.';
export const stepVehicleOwnershipLease = 'Lease';
export const stepVehicleOwnershipLeaseDescription = 'I am currently leasing this vehicle.';
export const stepVehicleOwnershipOwn = 'Own';
export const stepVehicleOwnershipOwnDescription = 'I currently own this vehicle outright.';
export const stepVehicleOwnershipType = 'Do you currently have a loan or lease on your vehicle?';
export const stepVehicleOwnershipBuyNewCar = 'Are you looking to buy a vehicle as well?';
export const stepVehicleOwnershipLoanInformation = 'Loan information';
export const stepVehicleOwnershipLoanCompany = 'Loan company';
export const stepVehicleOwnershipRemainingBalance = 'Remaining Balance';
export const stepVehicleOwnershipMontylyPayment = 'Monthly Payment';
export const stepVehicleOwnershipLeaseInformation = 'Lease information';
export const stepVehicleOwnershipLeaseCompany = 'Lease company';
export const stepVehicleOwnershipLeaseBalance = 'Lease payoff balance';
export const stepVehicleOwnershipVehicleInformation = 'Vehicle of Interest';

// Step Customer Information
export const stepCustomerInfoTitle = 'Get Your Price';
export const stepCustomerInfoSubtitle = 'We will need your information in order to view your quote price.';
export const stepCustomerInfoAskingPriceTitle = 'Anything else we should know about the vehicle?';
export const stepCustomerInfoAskingPriceLabel = 'Asking Price';
export const stepCustomerInfoNotesLabel = 'Notes';
export const stepCustomerInfoNoReferralCodeTitle = 'Do you have a referral code? (Optional)';
export const stepCustomerInfoNoReferralCodeLabel = 'Referral Code';
export const stepCustomerInfoTradeInTitle = 'Is this vehicle a trade-in or an acquisition?';
export const stepCustomerInfoAppraisalTitle = 'No users recorded for this store. Please contact admin.';
export const stepCustomerInfoAppraisalUser = 'Appraisal User';
export const stepCustomerInfoAppraisalStore = 'Appraisal Store';
export const stepCustomerInfoFirstNameLabel = 'First Name';
export const stepCustomerInvalidFirstNameLabel = 'Please enter a First Name.';
export const stepCustomerInfoLastNameLabel = 'Last Name';
export const stepCustomerInvalidLastNameLabel = 'Please enter a Last Name';
export const stepCustomerInfoPhone = 'Phone Number';
export const stepCustomerInvalidPhone = 'Please enter a Phone Number.';
export const stepCustomerInfoEmail = 'Email';
export const stepCustomerInvalidEmail = 'Email is not valid.';
export const stepCustomerInfoOptIn = 'I agree to the following';
export const stepCustomerInfoUnableToAddVehicle = 'Unable to add vehicle.';
export const stepCustomerNextText = 'Get My Price';

// Step Upload Photos
export const stepUploadPhotosInfoTitle = 'Upload Photos';
export const stepUploadPhotosReady = 'Ready to upload photos?';
export const stepUploadScanQRMessaage = "Scan the QR code below or send a link to your phone to start uploading your vehicle's photos.";
export const stepUploadScanQR = 'Scan the QR Code below';
export const stepUploadScanQRInfo = "Using your phone's camera, scan the code below to start uploading photos to get your offer.";
export const stepUploadReceiveSms = 'Receive link through SMS';
export const stepUploadReceiveSmsInfo = 'Click on the button on the right to send the link to your mobile phone.';
export const stepUploadTextLinkButton = 'Text link';
export const stepUploadBackToPricePage = 'Go back to your price page';
export const stepUploadConfirmNumberTitle = 'Confirm phone number';
export const stepUploadConfirmNumber = 'Please confirm your phone number below to receive your link and start taking photos of your vehicle.';
export const stepUploadSendLink = 'Send link';

// Terms and Agreement
export const termsAndAgreement = {
  standard: `ClearCar's Trade-In widget is brought to you by ACV Auctions Inc. I understand that I am under no obligation to sell my vehicle to the dealer identified on this web site ("Dealer") at any price, and the trade-in value estimate is a non-binding valuation only. By including my name, email, and/or phone number, I agree to receive communications from ACV Auctions Inc. ("ACV") and the Dealer (together with ACV, the "Widget Providers"), and I authorize the Widget Providers to deliver, or cause to be delivered, telephonic sales calls and text messages to me using automation and prerecorded messages. I understand I do not need to provide a mobile number as a condition of receiving a price trade-in value. I agree to ACV’s term_agreement, which explains how ACV uses and shares the data I provide to receive an estimated trade-in value for my vehicle, including the process by which I may opt out at any time. For information on the Dealer's privacy policies, I can contact the Dealer. Standard message and data rates may apply`,
  appraisal: `By including my name, I agree to receive communications from {0} and I authorize {0} to deliver, or cause to be delivered, telephonic sales calls and text messages to me using automation and prerecorded messages. I understand that {0} may share my contact information, and I can opt out at any time. I also agree to {0}’s Terms of Use and Privacy Policy, which explain how my data is used and shared with others, and if applicable, to any promotion terms and conditions. This consent is not a condition of any purchase. Standard message and data rates may apply.`,
  privacyPolicy: 'Notice at Collection/Privacy Policy',
};

// Online Price
export const stepOnlineEstimateVehicleEstimate = `Your Vehicle's Price`;
export const stepOnlineEstimateVehicleStore = `Your online price is ready from`;
export const stepOnlineEstimateWhatsNext = `What's next`;
export const stepOnlineEstimateVehicleValue = 'See what vehicles like yours are valued in the market';
export const stepOnlineEstimateAppointment = {
  title: 'Make an appointment',
  description: 'Schedule an appointment now with our dealer. A customer advocate will text you to schedule the appointment based on the information you have provided.',
};
export const stepOnlineEstimatePrint = 'Print';
export const stepOnlineEstimatePhotos = {
  title: 'Upload photos',
  description: ` Save time and get an updated price with photos of your vehicle.`,
  cta: 'Upload',
};
export const stepOnlineEstimateWhatToBring = {
  title: 'What to bring to sell your car',
  list: ['Car title or payoff information', 'Valid state-issued photo ID', 'Valid current vehicle registration', 'All keys and remotes for the vehicle', 'Payoff information (if applicable)'],
};

// What's behind your estimate
export const stepOnlineEstimateWhatsBehindYourEstimateTitle = `What's behind your price`;
export const stepOnlineEstimateWhatsBehindYourEstimate = {
  titleClean: 'Clean Title',
  titleNotClean: 'Title not clean',
  accidentOnce: 'One accident',
  accidentTwice: 'Two or more accidents',
  accidentNone: 'No accidents',
  accidentNoRecord: 'No accident record exist',
  tiresGood: 'Good',
  tiresClean: 'Clean tires',
  tiresIssues: 'Some tire issues',
  bodyDamage: '{0} body damage',
  bodyDamageNone: 'No body damage',
  interiorIssues: 'Some interior issues',
  interiorNoIssues: 'No interior issues',
  modificationsIssues: 'Some modifications',
  modificationsNone: 'No major modifications',
};

export const stepOnlineEstimateOfferExpires = 'Valid through {0} {1}';
export const stepOnlineEstimateCardMessage = 'of similar vehicles typically sell for';

export const stepOnlineEstimateMaxLimitTitle = 'Thank you for filling out the pricing form.';
export const stepOnlineEstimateMaxLimitNextSteps = ['Sit tight while your vehicle is being reviewed', 'Get your price via text or call', 'Schedule an appointment to get paid right away'];
export const stepOnlineEstimateYMMDescription = 'A representative will contact you to schedule an appointment and provide you a price. For an immediate price on your vehicle, please resubmit the form using a license plate or VIN.';

export const stepOnlineEstimateRedirect = 'Almost there{0}!';
export const stepOnlineEstimateRedirectMessage = 'We are redirecting you to your price page.';

export const stepOnlineEstimateSeeOffer = 'See price now';
export const stepOnlineEstimateGoHome = 'Go home';
export const stepOnlineEstimateDecline = 'Decline';
export const stepOnlineEstimateAccept = 'Accept';

export const stepOnlineEstimateMonkConfirmationMessage = 'Your link to take photos of your vehicle from your phone is: {0}';
export const stepOnlineEstimateYMMWarning = 'This price is an estimate, based on our historical data and trends. To receive a more accurate price, please resubmit using the License Plate Number or VIN information of your car.';

export const stepMonkConfirmationLinkSend = 'We have sent a link to your cellphone number.';
export const stepMonkConfirmationCheckMessage = 'Please check your message to see if you have gotten a link from us.';
export const stepMonkConfirmationNotReceiveMessage = `Didn't get the message?`;
export const stepMonkConfirmationResendMessage = 'Save time and get an updated price with photos of your vehicle.';
export const stepMonkConfirmationResendCTA = 'Resend link';
export const stepMonkConfirmationOr = 'or';
export const stepMonkConfirmationSeeOffer = 'View my price without uploading photos instead.';
export const stepMonkConfirmationSeeOfferCTA = 'View price';
export const stepOnlineEstimatePdfError = 'Unavailable PDF';

/** Error Step */
export const stepErrorTitle = 'Something went wrong';
export const stepErrorDescription = 'You are missing required information. Please updated as needed to load the tool.';
export const stepErrorFormDescription = 'Get your price by sending this form to our team of Auto Buddies, who will help review your vehicle information.';
export const stepErrorGetMyOffer = 'Get my price';

/** API */
export const apiErrorHttpClientGeneric = `HTTP client received an error. Details: {0}`;
export const apiErrorVinNotRetrieved = 'Unable to retrieve VIN. Please try again.';
export const apiErrorPlateNotRetrieved = 'Unable to retrieve license plate. Please use your VIN instead.';

// SMS
export const smsInspection = 'Hello {0},\n\nThank you for your interest. Here is your link from {1} to take photos of your vehicle with your phone: {2}';
export const smsOffer = 'Hello {0},\n\nPlease click on this link to view the custom price for your vehicle from {1}: {2}';

/**
 * Replace locale string variables represented by index numbers wrapped in curly
 * braces (e.g. {0}, {1} and {2})
 */
export const formatLocale = (locale = '', words: string | string[]) => {
  if (!!words) {
    const hasWords = Array.isArray(words);
    return hasWords ? words.reduce((str, val, index) => replaceMultipleTexts(str, `{${index}}`, val), locale) : locale.replace('{0}', words);
  }

  return locale;
};

//vin scanner
export const monkAccessTokenNotFetched = 'Monk access token not fetched';
export const monkVinInspectionNotCreated = 'Vin inspection not created';
export const monkVinNotGenerated = 'Vin not generated';
export const vinScannerCameraNotAccessible = 'Camera is not accessible';
export const vinScannerBlobNotCreated = 'Blob not created from data URI';

/** Quick quote locale **/

//Vehicle info
export const qqVehicleInfoTitle = 'Vehicle Info';
export const qqVehicleInfoHeaderSubTitle = 'Please review and update the information we have about your vehicle to ensure the most accurate price.';
export const qqVehicleInfoHeaderTitle = 'We found your car!';
export const qqYourVehicle = 'Your Vehicle';
export const qqVinNotFound = 'VIN cannot be found. Please verify your information.';
export const qqInvalidVin = 'Please enter a valid VIN.';
export const qqVIN = 'VIN';
export const qqRequiredField = '*Indicates a required field';
export const qqLicensePlateNotFound = 'License plate cannot be found. Please confirm the plate number.';
export const qqNoRecordFound = 'No vehicle record found';

// search vehicle
export const yearMakeModelPlaceholder = 'Search Year Make Model';
export const noResultsFound = 'No results found';

//Customer Information
export const qqCustomerInfoTitle = 'Your Information';
export const qqCustomerInfoHeaderSubTitle = `We'd love to learn more about you to provide a personalized price.`;
export const qqCustomerInfoDescription = 'To help you with pricing, please provide us with your information below.';

// Terms and Agreement quick quote
export const termsAndAgreementQuickQuote = {
  standard: `I understand that I am under no obligation to sell my vehicle to the dealer identified on this web site ("Dealer") at any price, and the trade-in value estimate is a non-binding valuation only. By including my name, email, and/or phone number, I agree to receive communications from ACV Auctions Inc. ("ACV") and the Dealer (together with ACV, the "Widget Providers"), and I authorize the Widget Providers to deliver, or cause to be delivered, telephonic sales calls and text messages to me using automation and prerecorded messages. I understand I do not need to provide a mobile number as a condition of receiving a price trade-in value. I agree to ACV’s term_agreement, which explains how ACV uses and shares the data I provide to receive an estimated trade-in value for my vehicle, including the process by which I may opt out at any time. For information on the Dealer's privacy policies, I can contact the Dealer. Standard message and data rates may apply`,
  appraisal: `By including my name, I agree to receive communications from {0} and I authorize {0} to deliver, or cause to be delivered, telephonic sales calls and text messages to me using automation and prerecorded messages. I understand that {0} may share my contact information, and I can opt out at any time. I also agree to {0}’s Terms of Use and Privacy Policy, which explain how my data is used and shared with others, and if applicable, to any promotion terms and conditions. This consent is not a condition of any purchase. Standard message and data rates may apply.`,
  privacyPolicy: 'Notice at Collection/Privacy Policy',
};

// Photo upload & Disclosure
export const qqSmsSent = 'SMS has been sent.';
export const qqSmsFailed = 'Unable to send SMS. Please try again later.';
export const qqSendLink = 'Send Link';
export const qqBackToPricePage = 'Go back to your price page';
export const qqDisclosureSmsModalHeading = 'Vehicle Disclosures';
export const qqDisclosureSmsModalTitle = 'Prefer to answer later?';
export const qqDisclosureSmsModalContent = 'Send a link to your phone to answer questions about your vehicle later to get an updated quote.';
export const qqRequestDisclosureMessage = 'Hello {0},\n\nThank you for your interest. Here is your link from {1} to complete an extended disclosure on your vehicle’s condition: {2}.';

// Price quick quote
export const qqPriceTitle = 'Your ClearCar Market Report is Ready';
export const qqVehicleCondition = 'Get a more accurate price when you answer our vehicle disclosure form.';
export const qqUploadPhotos = 'Click on the button below to start uploading your vehicle photos.';
export const qqVehicleConditionStart = 'Start';
export const qqVehicleConditionLater = "I'll do this later";
export const qqVehiclePriceDisclosure = 'The pricing for your vehicle is determined by comparing it to similar models. For a more precise price, please fill out the Vehicle Disclosures located at the bottom of this page.';
